'use client';

import { usePathname } from 'next/navigation';
import { LandingHeader } from './landing-header';
import { ProtectedHeader } from './protected-header';

const LOCALES = ['en', 'sr', 'si'] as const;

const LANDING_ROUTES = [
  '',
  'login',
  'register',
  'privacy',
  'terms',
  'contact',
  'about',
  'error',
  'reset-password',
  'new-password',
  'new-verification',
  'accept-invite',
  'invoice',
];

function isLandingRoute(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return true;
  const first = segments[0];
  if (
    segments.length === 1 &&
    LOCALES.includes(first as (typeof LOCALES)[number])
  )
    return true;
  if (
    segments.length >= 2 &&
    LOCALES.includes(segments[0] as (typeof LOCALES)[number]) &&
    LANDING_ROUTES.includes(segments[1])
  )
    return true;
  return false;
}

interface HeaderSwitcherProps {
  user: import('@/types/next-auth').ExtendedUser | null;
  dictionary: import('@/types').Dictionary;
}

export function HeaderSwitcher({ user, dictionary }: HeaderSwitcherProps) {
  const pathname = usePathname();

  if (!user && isLandingRoute(pathname)) {
    return <LandingHeader />;
  }

  return <ProtectedHeader user={user} dictionary={dictionary} />;
}
